import { useEffect } from 'react';
import {
  Grid,
  Typography,
  Modal,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import axios from 'axios';
import { quantityOptions } from '../../../../../data/forms/nrc/texasScratchTicketDropdownOptions.js'; 

export default function GameSelectModal({
  isOpen,
  handleClose,
  setForm,
  games,
}) {
  useEffect(() => {
    const fetchGames = async () => {
      // Only fetch if games array is empty or doesn't exist
      if (games && games.length > 0) {
        return; // Games already exist with quantities, don't reset them
      }

      const texasGamesEndpoint = process.env.REACT_APP_ITS_GAMES;
      try {
        const res = await axios.get(`${texasGamesEndpoint}/texas`);
        const gamesData = res.data;
        // Initialize games with empty quantities
        const updatedGames = gamesData.map(game => ({
          ...game,
          quantity: '',
        }));
        setForm(prevForm => ({
          ...prevForm,
          games: updatedGames,
        }));
      } catch (error) {
        const data = error?.response?.data;
        const url = error?.config?.url;

        console.error(
          `Error fetching Texas Scratch Ticket games: ${error.message} - ${url} - ${data}`
        );
      }
    };

    // Only fetch when modal opens and games don't exist
    if (isOpen) {
      fetchGames();
    }
  }, [isOpen, setForm, games]);

  const handleChange = (e, gameId) => {
    const { value } = e.target;
    setForm(prevForm => ({
      ...prevForm,
      games: prevForm.games.map(game =>
        game.gameId === gameId ? { ...game, quantity: value } : game
      ),
    }));
  };

  // API returns games sorted DESC by gameId
  // Distribute games horizontally: even indices (0, 2, 4...) go to left column,
  // odd indices (1, 3, 5...) go to right column
  const leftColumnGames = games.filter((_, index) => index % 2 === 0);
  const rightColumnGames = games.filter((_, index) => index % 2 === 1);

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Grid
        container
        spacing={2}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: '80%', md: '70%' },
          maxHeight: { xs: '80vh', sm: '80vh', md: '80vh' },
          overflowY: 'auto',
          bgcolor: 'var(--dust-white)',
          p: 4,
        }}
      >
        <Grid
          size={12}
          sx={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <Typography
            id='modal-modal-title'
            sx={{ fontFamily: 'BrightstarSans-Regular', fontSize: '25px' }}
          >
            {`Scratch Ticket Games`}
          </Typography>
          <Button
            variant='contained'
            sx={{ backgroundColor: 'var(--vega-blue)' }}
            onClick={handleClose}
          >
            {'Done'}
          </Button>
        </Grid>
        <Grid size={6}>
          {leftColumnGames.map(game => (
            <FormControl
              key={game.gameId}
              sx={{
                backgroundColor: '#ffffff',
                marginBottom: '15px',
                width: '100%',
              }}
            >
              <InputLabel>{game.display}</InputLabel>
              <Select
                value={game.quantity || ''}
                label={`${game.display}`}
                onChange={e => handleChange(e, game.gameId)}
                name={game.gameId}
              >
                {quantityOptions.map(option => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ))}
        </Grid>
        <Grid size={6}>
          {rightColumnGames.map(game => (
            <FormControl
              key={game.gameId}
              sx={{
                backgroundColor: '#ffffff',
                marginBottom: '15px',
                width: '100%',
              }}
            >
              <InputLabel>{game.display}</InputLabel>
              <Select
                value={game.quantity || ''}
                label={`${game.display}`}
                onChange={e => handleChange(e, game.gameId)}
                name={game.gameId}
              >
                {quantityOptions.map(option => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          ))}
        </Grid>
      </Grid>
    </Modal>
  );
}
